module.exports = __webpack_public_path__ + "img/zoomed-Cybersecurity-withwords.afd17242.png";